<template>
  <div class="cell-wrapper">
    <div class="cell-title flex">
      <div class="list-left">
        <UserAvatar :src="apply.relationUserInfo.headImgUrl" />
      </div>
      <div class="list-right relative">
        <div class="content-top flex justify-c_space-b">
          <p class="user-wrapper">
            <span class="name text-ellipsis">{{ initApplicantName }}</span>
            <span class="male" v-if="apply.relationUserInfo.sex == 1"
              ><i class="el-icon-male"></i
            ></span>
            <span class="female" v-else><i class="el-icon-female"></i></span>
          </p>
          <span class="time">{{ date }}</span>
        </div>
        <div class="content-bottom flex">
          <p class="lastmsg text-ellipsis">{{ initApply }}</p>
          <p class="respond-menu" v-if="apply.agree == 0">
            <span class="agree" @click="agreeConfirm">同意</span>
            <span class="decline" @click="declineApply">拒绝</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFullDate } from "../utils/date";
import { apiMap } from "../utils/apiMap";
import UserAvatar from "./UserAvatar";
import qs from "qs";
export default {
  name: "hand-lian-apply",
  props: {
    apply: Object,
  },
  components: {
    UserAvatar,
  },
  computed: {
    date() {
      return getFullDate(new Date(this.apply.created_at * 1000));
    },
    initApply() {
      let appellation = "他";
      if (this.apply.relationUserInfo.sex == 2) {
        appellation = "她";
      }
      let displayRelation = this.apply.relationName;
      if (this.apply.relationName == "儿女") {
        displayRelation = "女儿";
      }
      switch (this.apply.agree) {
        case 0:
          return `对方想传连你为${appellation}的 ${displayRelation}`;
        case 1:
          return `对方同意你传连为${appellation}的 ${displayRelation}`;
        case 2:
          return `对方拒绝你传连为${appellation}的 ${displayRelation}`;
      }
    },
    initApplicantName() {
      return (
        this.apply.relationUserInfo.realName || this.apply.relationUserInfo.name
      );
    },
  },
  methods: {
    agreeConfirm() {
      let displayRelation = this.apply.relationName;
      if (this.apply.relationName == "儿女") {
        displayRelation = "女儿";
      }
      var applicantName =
        this.apply.relationUserInfo.realName ||
        this.apply.relationUserInfo.name;
      let tipText = `我是 ${applicantName} 的 ${displayRelation}`;
      this.$confirm(tipText, "为了保证家谱图正确，请再三核对：", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "cl-copy-confirm",
        closeOnClickModal: false,
        showClose: false,
      })
        .then(() => {
          this.respondApply(1);
        })
        .catch(() => {});
    },
    respondApply(agree) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["respondRelation"]["method"],
          url: apiMap["respondRelation"]["url"],
          data:
            "token=" +
            loginUser.token +
            "&relationUserId=" +
            _this.apply.userId +
            "&agree=" +
            agree,
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            if (agree == 1) {
              // 同意传联
              // {relationName}比如申请者 叫当前登录的这个人为 '哥哥'，此参数为'哥哥'
              // {relationUserId}接受者的Id (即当前登录的userId )
              // {userId}申请者的Id
              let params = {
                token: loginUser.token,
                relationName: _this.apply.relationName,
                relationUserId: loginUser.userId,
                userId: _this.apply.userId,
              };
              _this.setUpRelation(params);
            }
            setTimeout(() => {
              Store.dispatch("deleteHandLianAppy", _this.apply.id);
            }, 1000);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    declineApply() {
      this.$confirm("确定拒绝这条传联申请吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "cl-copy-confirm",
        showClose: false,
        type: "warning",
      })
        .then(() => {
          this.respondApply(0);
        })
        .catch(() => {});
    },
    //建立传联关系
    setUpRelation(params) {
      let $this = this;
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["createRelation"]["method"],
          url: apiMap["createRelation"]["url"],
          data: qs.stringify(params, { encode: false }),
        })
        .then(function (response) {
          switch (response.data.result.statusCode) {
            case 0:
              $this
                .$alert(response.data.result.data)
                .then(() => {})
                .catch(() => {});
              break;
            case 1:
              $this
                .$alert("传连成功")
                .then(() => {})
                .catch(() => {});
              break;
            case 2:
              $this.startRelationInteraction(params, response.data.result);
              break;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //更新好友关系链，移动分组
    updateFriendRelationChain() {},
    //传联关系交互，传联目标有多个配偶时
    startRelationInteraction(submit, respond) {
      if (!Array.isArray(respond.data)) {
        return;
      }
      if (respond.data.length > 0) {
        let optionArr = [];
        const h = this.$createElement;
        optionArr.push(h("option", { attrs: { value: "" } }, "—— 亲人 ——"));
        respond.data.forEach((item) => {
          optionArr.push(
            h(
              "option",
              {
                attrs: {
                  value: item.userId,
                },
              },
              `${item.name}${item.sex === 1 ? " (男)" : " (女)"}`
            )
          );
        });
        optionArr.push(h("option", { attrs: { value: "-1" } }, "其他"));
        this.$msgbox({
          title: "请选择血缘关系人",
          message: h("div", null, [
            h(
              "select",
              {
                attrs: {
                  id: "relativeMate",
                  class: "handlian-select",
                },
              },
              optionArr
            ),
          ]),
          showCancelButton: true,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            let selectedID = document.getElementById("relativeMate").value;
            if (action === "confirm") {
              // console.log(selectedID);
              if (selectedID == "") {
                this.$message({
                  type: "warning",
                  message: "请选择一个亲人",
                });
                return;
              }
              Object.defineProperty(submit, respond.field, {
                value: selectedID,
                writable: true,
                enumerable: true,
                configurable: true,
              });
              // let submitData = submit+'&nodeUserId='+selectedID;
              this.setUpRelation(submit);
              done();
            } else {
              // let submitData = submit+'&nodeUserId=-1';
              Object.defineProperty(submit, respond.field, {
                value: "-1",
                writable: true,
                enumerable: true,
                configurable: true,
              });
              this.setUpRelation(submit);
              done();
            }
          },
        })
          .then(() => {})
          .catch(() => {});
      } else {
        // let submitData = submit+'&nodeUserId=-1';
        Object.defineProperty(submit, respond.field, {
          value: "-1",
          writable: true,
          enumerable: true,
          configurable: true,
        });
        this.setUpRelation(submit);
      }
    },
  },
};
</script>
<style scoped>
.cell-wrapper {
  width: 650px;
  background-color: #fff;
  border-bottom: 1px solid #f6f7f8;
  margin-bottom: 2px;
}

.flex {
  display: flex;
  flex-flow: row nowrap;
}

.justify-c_space-b {
  justify-content: space-between;
}

.relative {
  position: relative;
}

.cell-title .list-left {
  margin: 0 10px;
  display: flex;
  align-items: center;
}

.list-left .avatar-box {
  position: relative;
  width: 50px;
  height: 50px;
}

.cell-wrapper .cell-title {
  height: 60px;
}

.user-wrapper .name {
  display: inline-block;
  max-width: 300px;
  margin: 0;
  vertical-align: top;
  font-size: 16px;
}

.user-wrapper .male {
  margin-left: 5px;
  color: #0071ff;
}

.user-wrapper .female {
  margin-left: 5px;
  color: #ff4081;
}

.content-top .time {
  color: #51555e;
  vertical-align: top;
}

.cell-title .list-right {
  flex: auto;
}

.list-right .content-top {
  margin-top: 5px;
  margin-right: 15px;
  line-height: 20px;
}

.list-right .content-bottom {
  margin-right: 15px;
  margin-top: 10px;
  align-items: center;
  justify-content: space-between;
}

.list-right .remove-session-btn {
  display: none;
  position: absolute;
  top: 28px;
  right: 14px;
  cursor: pointer;
  color: #409eff;
}

.cell-wrapper:hover .remove-session-btn {
  display: inline-block;
}

.remove-session-btn:hover {
  color: #ff0000;
}

.content-bottom .lastmsg {
  max-width: 520px;
}

.content-bottom .respond-menu {
  display: none;
}

.respond-menu span {
  padding: 0 4px;
  color: #666666;
  cursor: pointer;
}

.respond-menu .agree {
  margin-right: 18px;
}

.respond-menu .agree:hover {
  color: #33cc33;
}

.respond-menu .decline:hover {
  color: #ff0000;
}

.cell-title:hover .respond-menu {
  display: block;
}
</style>